"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Text.css");

var _styles = {
  "text": "Text__text___1tZcV",
  "text-11": "Text__text-11___1tr4x",
  "text-13": "Text__text-13___yZhtZ",
  "text-15": "Text__text-15___XRZyu",
  "text-18": "Text__text-18___1yp5X",
  "text-23": "Text__text-23___2CXSL",
  "text-32": "Text__text-32___3VAm2",
  "text-40": "Text__text-40___K22a8",
  "text-48": "Text__text-48___2uWLN",
  "regular": "Text__regular___3ms5E",
  "medium": "Text__medium___3CMZU",
  "bold": "Text__bold___1J9Hk",
  "italic": "Text__italic___SYzPf",
  "regular-all-caps": "Text__regular-all-caps___1xyAR",
  "medium-all-caps": "Text__medium-all-caps___1pJlM",
  "italic-all-caps": "Text__italic-all-caps___3qn9z",
  "success": "Text__success___RLx4B",
  "failed": "Text__failed___3x41-",
  "warning": "Text__warning___1HbMU",
  "in_process": "Text__in_process____gSTe",
  "disabled": "Text__disabled___3JUqE"
};

const styles = _bind.default.bind(_styles);

const TextRoot = (0, _react.forwardRef)(({
  className,
  children,
  variant = 'regular',
  tag: Tag = 'p',
  size = 15,
  status,
  textAlign,
  disabled,
  color,
  text,
  dataTestId,
  paddingBottom,
  ...props
}, ref) => {
  const composed_classname = (0, _bind.default)(styles('text', variant, `text-${size}`, status, Tag, {
    disabled: disabled
  }), className);
  const composed_styles = {
    textAlign,
    color,
    paddingBottom: paddingBottom && `${paddingBottom}px`
  };
  return _react.default.createElement(Tag, {
    ref: ref,
    className: composed_classname,
    style: composed_styles,
    "data-testid": dataTestId,
    ...props
  }, children || text);
});
TextRoot.displayName = 'Text';
const Text = (0, _mobxReact.observer)(TextRoot);
var _default = Text;
exports.default = _default;